<template>
  <div class="u-pad-v--4 u-fg--black">
    <div class="o-container o-container--responsive">
      <div class="o-layout o-layout--responsive">
        <div class="o-layout__item u-mrgn-top--2 u-mrgn-bottom--5">
          <Breadcrumb :this-page="thisPage" :other-links="otherBreadcrumbLink" />
        </div>
      </div>
      <h1 class="u-txt--bold u-txt--medium u-mrgn-bottom--3">Jenis Reksa Dana</h1>
      <div class="u-txt--base u-line-height--20" v-html="pageDescription" />
      <div>
        <div v-for="(content, index) in contentData" :key="index">
          <GeneralItem
            :title="content.name"
            :desc="content.desc"
            :link="baseUrl + content.link_url"
            :info-title="['Resiko', 'Keuntungan', 'Instrumen Investasi']"
            :info-data="[content.risk, content.profit, content.instrument]"
            :other-name="content.other_name"
          />
        </div>
      </div>
      <div><OtherLinkFooter :other-links="otherLinks" /></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from 'shared/components/desktop/Breadcrumb';
import GeneralItem from 'shared/components/desktop/GeneralItem';
import OtherLinkFooter from 'shared/components/desktop/OtherLinkFooter';

export default {
  name: 'TypeIndexDesktop',
  components: {
    Breadcrumb,
    GeneralItem,
    OtherLinkFooter,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    pageDescription: {
      type: String,
      default: '',
    },
    baseUrl: {
      type: String,
      default: '',
    },
    contentData: {
      type: Object,
      default: () => ({}),
    },
    breadcrumbLinks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    thisPage() {
      return this.breadcrumbLinks.find(link => link.isActive);
    },
    otherBreadcrumbLink() {
      return this.breadcrumbLinks.filter(link => !link.isActive);
    },
  },
};
</script>
